

export class DzswtlPagination{
  /**
   *
   * @param  selfClass
   */
  constructor(selfClass) {
    this.selfClass = selfClass;
    this.initPagination()
  }

  initPagination(){
    const self = this;
    jQuery('.woo-table--gotoPage--input').on('keyup blur', handle_gotoPage_key);


    function handle_gotoPage_key(e){
      const theVal = e.currentTarget.value;


      if(window.dzswtl_lastValPag!==theVal){

        self.selfClass.load_new_content({
          paged: theVal
        })
      }
      window.dzswtl_lastValPag = theVal;
    }
  }

}